import { render } from "./credit-segmentation.vue?vue&type=template&id=6d231008&scoped=true"
import script from "./credit-segmentation.vue?vue&type=script&lang=js"
export * from "./credit-segmentation.vue?vue&type=script&lang=js"

import "./credit-segmentation.vue?vue&type=style&index=0&id=6d231008&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d231008"]])

export default __exports__